import client from './client';

export const listTenants = (params) =>
  client.get('/tenants', { params }).then((r) => r.data);

export const getTenant = (id) =>
  client.get(`/tenants/${id}`).then((r) => r.data);

export const createTenant = (data) =>
  client.post('/tenants', data).then((r) => r.data);

export const updateTenant = (id, data) =>
  client.put(`/tenants/${id}`, data).then((r) => r.data);

export const deleteTenant = (id) =>
  client.delete(`/tenants/${id}`).then((r) => r.data);

// Promote a shadow FPA to a live one (super admin only). Only clears the
// flag; users still have to be invited. Nothing is migrated because nothing
// needs to be — the tenant id never changes, so mutual-aid records already
// pointing at this FPA resolve the moment its first user signs in.
export const activateTenant = (id) =>
  client.post(`/tenants/${id}/activate`).then((r) => r.data);

export const repartition = (tenantId) =>
  client.post(`/tenants/${tenantId}/repartition`).then((r) => r.data);

export const getRepartitionJob = (tenantId, jobId) =>
  client.get(`/tenants/${tenantId}/repartition-jobs/${jobId}`).then((r) => r.data);

export const listRepartitionJobs = (tenantId, params) =>
  client.get(`/tenants/${tenantId}/repartition-jobs`, { params }).then((r) => r.data);

export const markRepartitionJobFailed = (tenantId, jobId) =>
  client.post(`/tenants/${tenantId}/repartition-jobs/${jobId}/mark-failed`).then((r) => r.data);
